import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=04dea4b4&scoped=true&"
import script from "./Dropdown.vue?vue&type=script&lang=js&"
export * from "./Dropdown.vue?vue&type=script&lang=js&"
import style0 from "./Dropdown.vue?vue&type=style&index=0&id=04dea4b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dea4b4",
  null
  
)

export default component.exports